// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/6389853a707ed42ce580.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"62cae60eec6ea698a3a3","118":"6b9fa2dd330098001ca5","119":"754179472468aaa413c0"}[chunkId] + ".chunk.js";
};